if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      constructor() {
        super();
        this.tiers = Array.from(this.querySelectorAll('[data-bundle-tier]'));
        this.button = this.querySelector('[data-bundle-add]');
        this.errorElement = this.querySelector('[data-bundle-error]');

        this.tiers.forEach((tier) => {
          tier.querySelector('input[type="radio"]').addEventListener('change', () => this.selectTier(tier));
        });
        this.button.addEventListener('click', this.addToCart.bind(this));
        this.querySelectorAll('select').forEach((select) =>
          select.addEventListener('change', () => this.showVariantImage(select))
        );
      }

      showVariantImage(select) {
        const option = select.selectedOptions[0];
        const { image } = option.dataset;

        const thumb = select.closest('.bundle-tier__row')?.querySelector('.bundle-tier__thumb');
        if (thumb && image) {
          thumb.removeAttribute('srcset');
          thumb.src = image;
        }
      }

      selectTier(selected) {
        this.tiers.forEach((tier) => tier.classList.toggle('is-selected', tier === selected));
      }

      get cartElement() {
        return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      }

      showError(message) {
        this.errorElement.textContent = message;
        this.errorElement.hidden = !message;
      }

      async addToCart() {
        const selectedTier = this.tiers.find((tier) => tier.classList.contains('is-selected'));
        if (!selectedTier) return;

        const quantities = {};
        selectedTier.querySelectorAll('select, input[data-bundle-variant]').forEach((select) => {
          quantities[select.value] = (quantities[select.value] || 0) + 1;
        });
        const items = Object.entries(quantities).map(([id, quantity]) => ({ id: Number(id), quantity }));

        const cart = this.cartElement;
        const body = { items };
        if (cart) {
          body.sections = cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        this.showError('');
        this.button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body: JSON.stringify(body) });
          const state = await response.json();

          if (!response.ok || state.status) {
            this.showError(state.description || state.message || 'Could not add to cart.');
            return;
          }

          if (cart && state.sections) {
            cart.renderContents({ ...state.items[state.items.length - 1], sections: state.sections });
            cart.classList.remove('is-empty');
          } else {
            window.location.href = window.routes.cart_url;
          }
        } catch (error) {
          console.error(error);
          this.showError('Could not add to cart.');
        } finally {
          this.button.removeAttribute('aria-busy');
        }
      }
    }
  );
}
